import API from "../../../common/utils/API";
import authService from "../../../auth/AuthService";
import {addEditDPServiceActionTypes} from "../constants/AddEditActionConstants";
import {apiActionsDPService} from "../../../middlewares/veritas-middleware/constants/ApiMiddlewareConstants";
import {displayWarningMessage} from "../../../common/marvel-reducers/formMessageActions";

const updatedDPService = () => ({
    type: addEditDPServiceActionTypes.UPDATED_DP_SERVICE_REFRESH,
});

const setInputFieldsValue = (inputFields) => ({
    type: "SETTING_SUPPORTING_SELECTIONS",
    payload: inputFields
});

const setDPServiceForm = ({ name, value, change_obj }) => ({
    type: addEditDPServiceActionTypes.SETTING_DPSERVICE_FORM_OBJECT_VALUE,
    payload: { name, value, change_obj },
});

export function setDPServiceFormValues({ name, value, change_obj }) {
    return (dispatch) => {
        dispatch(setDPServiceForm({ name, value, change_obj }));
    }
}

const validateDPServiceForm = (serviceObject, toDelete, authToken) => ({
    type: addEditDPServiceActionTypes.VALIDATE_DP_SERVICE_FORM,
    payload: { serviceObject, toDelete, authToken }
});

export function validateDPService(serviceObject, toDelete) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(validateDPServiceForm(serviceObject, toDelete, authToken))
    }
}

export function updatedDPServiceRefresh() {
    return (dispatch) => {
        dispatch(updatedDPService());
    }
}

// maybe shift this under get detail API to leverage that data
export function loadResourcesForDPServiceForm() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        API.getSupportingSelections(authToken.idToken)
            .then(res => {
                dispatch(setInputFieldsValueAction(res.data));
            })
            .catch(error => {
                console.error(error);
                throw error;
        });
    }
}

const updatePrimarySvcConfigName = ({value}) => ({
    type: addEditDPServiceActionTypes.MARK_AS_PRIMARY_SERVICE_CONFIG_NAME,
    payload: {value}
})

const delSvcConfigName = ({value}) => ({
    type: addEditDPServiceActionTypes.DELETE_FROM_ASSOCIATED_SERVICE_CONFIG_NAMES,
    payload: {value}
})

const updateSvcArr = (selectedServiceConfigNamesArr) => ({
    type: addEditDPServiceActionTypes.ADD_TO_SELECTED_SERVICE_CONFIG_NAMES,
    payload: selectedServiceConfigNamesArr
})

const setBillingGroup = (bg, change_obj) => ({
    type: addEditDPServiceActionTypes.SELECT_BILLING_GROUP,
    payload: {bg, change_obj}
})

const updateProviderDropdowns = (bg, change_obj) => ({
    type: addEditDPServiceActionTypes.SELECT_DATA_PROVIDER,
    payload: {bg, change_obj}
})

const updateServiceDetailDropdowns = (bg, change_obj) => ({
    type: addEditDPServiceActionTypes.UPDATE_DP_TYPE_INTEGRATION_STATUS,
    payload: {bg, change_obj}
})

const updateServiceSet = (bg, all_service_config_names, change_obj) => ({
    type: addEditDPServiceActionTypes.SELECT_SERVICE_SET,
    payload: {bg, all_service_config_names, change_obj}
})

const updateNotesDPServices = ({ name, value }) => ({
    type: addEditDPServiceActionTypes.UPDATE_DP_SERVICE_NOTES,
    payload: { name, value }
})

const updateContactDPServices = ({ name, value, change_obj }) => ({
    type: addEditDPServiceActionTypes.UPDATE_DP_SERVICES_CONTACT,
    payload: { name, value, change_obj }
})

const addToServiceConfigNames = () => ({
    type: addEditDPServiceActionTypes.ADD_TO_ASSOCIATED_SERVICE_CONFIG_NAMES
})

const createNewService = (scnObject, authToken) => ({
    type: apiActionsDPService.CREATE_SERVICE_CONFIG_NAME,
    payload: {scnObject, authToken}
})

const copyExistingService = (copyObject, authToken) => ({
    type: apiActionsDPService.COPY_SERVICE,
    payload: {copyObject, authToken}
});

const createNewNotesObject = (notesObject) => ({
    type: "CREATE_NEW_NOTE",
    payload: {notesObject}
})

const editExistingReqInputsGroup = (editInputsArray, editIndexOfInputGroup, countryCode) => ({
    type: addEditDPServiceActionTypes.EDIT_EXISTING_INPUT_GROUP,
    payload: {editInputsArray, editIndexOfInputGroup, countryCode}
});

const prepInputKeys = () => ({
    type: addEditDPServiceActionTypes.PREP_INPUT_KEYS
})

const delReqInputGroup = (deleteIndexOfInputGroup, countryCode) => ({
    type: addEditDPServiceActionTypes.DELETE_SELECTED_INPUT_GROUP,
    payload: {deleteIndexOfInputGroup, countryCode}
})

const addNewInputGroups = (editInputsArray) => ({
    type: addEditDPServiceActionTypes.ADD_NEW_REQUIRED_INPUT_GROUP,
    payload: {editInputsArray}
});

export function formatInputKeys() {
    return (dispatch) => {
        dispatch(prepInputKeys());
    }
}

export function setInputFieldsValueAction(inputFields) {
    return (dispatch) => {
        dispatch(setInputFieldsValue(inputFields))
    }
}

export function updatePrimaryServiceConfigName({value}) {
    return (dispatch) => {
        dispatch(updatePrimarySvcConfigName({value}))
    }
}

export function updateSvcConfigNamesArr(selectedServiceConfigNamesArr) {
    return (dispatch) => {
        dispatch(updateSvcArr(selectedServiceConfigNamesArr))
    }
}

export function updateProviderDropdownChanges(bg, change_obj) {
    return (dispatch) => {
        dispatch(updateProviderDropdowns(bg, change_obj))
    }
}

export function updateServiceDetailDropdownChanges(bg, change_obj) {
    return (dispatch) => {
        dispatch(updateServiceDetailDropdowns(bg, change_obj))
    }
}

export function selectBillingGroup(bg, change_obj) {
    return (dispatch) => {
        dispatch(setBillingGroup(bg, change_obj))
    }
}

export function updateNotesField({ name, value }) {
    return (dispatch) => {
        dispatch(updateNotesDPServices({ name, value }))
    }
}

export function updateContactInfoField({ name, value, change_obj }) {
    return (dispatch) => {
        dispatch(updateContactDPServices({ name, value, change_obj }))
    }
}

export function addNewServiceConfigNames() {
    return (dispatch) => {
        dispatch(addToServiceConfigNames())
    }
}

export function selectServiceSet(bg, all_service_config_names, change_obj) {
    return (dispatch) => {
        dispatch(updateServiceSet(bg, all_service_config_names, change_obj))
    }
}

export function deleteSvcConfigName({value}) {
    return (dispatch) => {
        dispatch(delSvcConfigName({value}))
    }
}

export function createServiceConfigName(scnObject) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(createNewService(scnObject, authToken.idToken))
    }
}

export function copyServiceConfigName(copyObject) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(copyExistingService(copyObject, authToken.idToken))
    }
}

export function createNewNote(notesObject) {
    return async (dispatch) => {
        dispatch(createNewNotesObject(notesObject))
    }
}

export function editReqInputGroup(editInputsArray, editIndexOfInputGroup, countryCode) {
    return (dispatch) => {
        // this will most likely not happen as we freeze the country selection while editing
        // but keeping this check just in case
        if (countryCode === 'ZZZ') {
            dispatch(displayWarningMessage(
                ["Please Select A Valid Country for Required Inputs"], true))
        } else {
            dispatch(editExistingReqInputsGroup(editInputsArray, editIndexOfInputGroup, countryCode))
            dispatch(prepInputKeys())
        }
    }
}

export function delInputGroup(deleteIndexOfInputGroup, countryCode) {
    return (dispatch) => {
        dispatch(delReqInputGroup(deleteIndexOfInputGroup, countryCode))
        dispatch(prepInputKeys())
    }
}

export function addNewReqInputsGroup(editInputsArray, countryCode) {
    return (dispatch) => {
        // adding a check to ensure that the form's state default option is not passed through.
        if (countryCode === 'ZZZ') {
            dispatch(displayWarningMessage(
                ["Please Select A Valid Country for Required Inputs"], true))
        } else {
            dispatch(addNewInputGroups(editInputsArray))
            dispatch(prepInputKeys())
        }
    }
}
